export const reviewWriteValues = {
  rating: [1, 2, 3, 4, 5]
}
